import React, { useEffect, useState } from "react";
import { isHomePage } from "../utils/utils";

import { Link } from "gatsby";
import arrow from "../assets/gray-arrow.svg";
import newLogo from "../assets/NewLogo.jpg";

import menu from "../assets/menu-mobile.svg";
import Sidebar from "./Sidebar";
import "./styles/Header.css";
import TopBanner from "./TopBanner";

import { isMobile } from "react-device-detect";
import HomepageAlertBanner from './HomepageAlertBanner';

const Header = ({location}) => {
  const [openSidebar, set0penSidebar] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const [belowThree, setBelowThree] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY <= 40) {
        setBelowThree(false);
      } else {
        setBelowThree(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSidebar(true);
    }, 500); // Adjust the delay as needed

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div>
      <HomepageAlertBanner/>
      {isMobile ? null : (
        <div className={`${"hideTopBanner"} scrolled-${belowThree}`}>
          <TopBanner />
        </div>
      )}
      <header
        className={`${
          isMobile
            ? "belowThreeMobile" + ' scrolled-' + belowThree
            : belowThree
            ? "belowThreeDesktop"
            : "header"
        }`}
      >
        <div className="align-mobile"></div>
        <Link to="/">
          <img src={newLogo} alt="logo nyga" className="mainLogo" />
        </Link>
        <ul
          className={`${isHomePage() ? "menu-links" : "menu-links"} ${
            isMobile ? "mobileDivUl" : ""
          }`}
        >
          <li className="link about-hover">
            <span>
              About Us
              <img
                src={arrow}
                className="header-arrow header-arrow-about"
                alt="arrow"
              />
            </span>
            <div className="about-drop-down">
              <Link to="/why-nyga">Why NYGA</Link>
              <Link to="/patient-reviews">Patient Reviews</Link>
              <Link to="/webinars">Webinars</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/news">News</Link>
              <Link to="/administration">Administration</Link>
            </div>
          </li>
          <li className="linkProv">
            <a href="/providers">Providers</a>
          </li>
          <li className="link location-hover">
            <span>
              Locations
              <img
                src={arrow}
                className="header-arrow header-arrow-location"
                alt="arrow"
              />
            </span>
            <div className="location-drop-down">
              <Link to="/locations">Offices</Link>
              <Link to="/surgery-centers">Surgery Centers</Link>
            </div>
          </li>
          <li className="link speciality-hover">
            <span>
              Specialties
              <img
                src={arrow}
                className="header-arrow header-arrow-speciality"
                alt="arrow"
              />
            </span>
            <div className="speciality-drop-down">
              <Link to="/services">Services</Link>
              <Link to="/conditions">Conditions</Link>
            </div>
          </li>
          <li className="linkProv">
            <Link to="/clinical-research">Clinical Research</Link>
          </li>
          <li
            className={`${
              isHomePage()
                ? "link how-link how-hover"
                : "link how-link how-hover"
            }`}
          >
            <span>
              How can we help you?
              <img
                src={arrow}
                className="header-arrow header-arrow-how"
                alt="arrow"
              />
            </span>
            <div className="how-drop-down">
              <Link to="/specialties/not-feeling-well">Not Feeling Well</Link>
              <Link to="/specialties/screening-colonoscopy">
                Screening Colonoscopy
              </Link>
              <Link to="/specialties/crohns-colitis-management">
                Crohn’s & Colitis Management
              </Link>
              <Link to="/specialties/womens-digestive-health">
                Women’s Digestive Health
              </Link>
              <Link to="/specialties/hemorrhoids">Hemorrhoids</Link>
              <Link to="/specialties/liver-health">Liver Health</Link>
              <Link to="/specialties/nutrition-counseling">
                Nutrition Counseling
              </Link>
            </div>
          </li>

          <li
            className={`${
              isHomePage()
                ? "link patient-link patient-hover"
                : "link patient-link patient-hover"
            }`}
          >
            <span>
              Patient Resources
              <img
                src={arrow}
                className="header-arrow header-arrow-patient"
                alt="arrow"
              />
            </span>
            <div className="patient-drop-down">
              <Link to="/frequently-asked-questions">Frequently Asked Questions</Link>
              <Link to="/patient-forms">Patient Forms</Link>
              <Link to="/prepare-for-procedure">Procedure and Test Prep</Link>
              <Link to="/accepted-insurances">Accepted Insurances</Link>
            </div>
          </li>
        </ul>
        <div
          className="align-mobile"
          onClick={() => {
            set0penSidebar(!openSidebar);
          }}
        >
          <img src={menu} alt="menu mobile" className="burgerIcon" />
        </div>
      </header>

      {showSidebar && (
        <Sidebar set0penSidebar={set0penSidebar} isOpen={openSidebar} />
      )}
    </div>
  );
};

export default Header;
